import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { GeneralResponseDTO } from "../../dtos/response/general.response.dto";
import { catchError, map, Observable, throwError } from "rxjs";
import { GetListaViajesResponseDTO } from "../../dtos/response/getListaViajes.response.dto";
import { GetListaMovilesResponseDTO } from '../../dtos/response/getListaBuses.response.dto';
import { GetDetalleViajeResponseDTO } from "../../dtos/response/getDetalleViaje.response.dto";
import { GetParadasViajeResponseDTO } from "../../dtos/response/getParadasViaje.response.dto";
import { PostFinalizarViajeResquestDTO } from "../../dtos/request/postFinalizarViaje.resquest.dto";
import { GetListaJorndasResponseDTO } from "../../dtos/response/getListaJornadas.response.dto";
import { GetKPISgestionJornadaResponseDTO } from "../../dtos/response/getKPISgestionJornada.response.dto";
import { GetListaSucursalesResponseDTO } from "../../dtos/response/getListaSucursales.response.dto";
import { GetListaConductoresResponseDTO } from '../../dtos/response/getListaConductores.response.dto';
import { GetListaParaderosResponseDTO } from '../../dtos/response/getListaParaderos.response.dto';
import { GetDetalleJornadaResponseDTO } from "../../dtos/response/getDetalleJornada.response.dto";
import { GetKPISGestionConductoresResponseDTO } from '../../dtos/response/getKPISgestionConductores.response.dto';
import { PutActualizarHoraJornadaResquestDTO } from "../../dtos/request/putActualizarHoraJornada.resquest.dto";
import { PostCrearJornadaResquestDTO } from "../../dtos/request/postCrearJornada.resquest.dto";
import { GetListaServiciosResponseDTO } from '../../dtos/response/getListaServicios.response.dto';
import { PdfDTO } from "../../dtos/pdf.dto";
import { GetListaViajesEspecialesResponseDTO } from '../../dtos/response/getListaViajesEspeciale.response.dto';
import { GetDetalleMovilResponseDTO } from "../../dtos/response/getDetalleMovil.response.dto";
import { GetListaMotivosCierreJornadaResponseDTO } from '../../dtos/response/getListaMotivosCierreJornada.response.dto';
import { GetDetalleConductorResponseDTO } from "../../dtos/response/getDetalleConductor.response.dto";
import { GetListaServiciosV3ResponseDTO } from '../../dtos/response/getListaServiciosV3.response.dto';
import { GetPermisosResponseDTO } from '../../dtos/response/getPermisos.response.dto';
import { GetConfiguracionEstadosConductorResponseDTO } from '../../dtos/response/getConfiguracionEstadosConductor.response.dto';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private host: string = environment.hostUrl;
  private hostSinoptico: string = environment.hostSinopticoUrl;
  private hostDespachador: string = environment.hostDespachadorUrl;
  private apiary: string = environment.apiaryUrl;
  private apiaryGestionSinopticoUrl: string = environment.apiaryGestionSinopticoUrl;
  private apiaryGestionJornadaUrl: string = environment.apiaryGestionJornadaUrl;
  private apiaryDespachadorUrl: string = environment.hostDespachadorUrl;
  private apiaryGestionBusesUrl: string = environment.apiaryGestionBusesUrl;
  private apiaryGestionConductoresUrl: string = environment.apiaryGestionConductoresUrl;

  constructor(private http: HttpClient) { }

  getPermisos(): Observable<GetPermisosResponseDTO> {
    return this.http.get<GetPermisosResponseDTO>(this.hostDespachador + "v1/permisos")
      .pipe(map(resp => new GetPermisosResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaConductores(
    page: number = 0,
    pageSize: number = 10,
    sucursalUuid: string = '',
    textoLibre: string = '',
    orderBy: string = 'visibleId',
    orderAsc: boolean = true,
    soloActivos: boolean = false,
    filtro: string = '',
    tipoBusqueda: string = '',
  ): Observable<GetListaConductoresResponseDTO> {
    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('orderBy', orderBy)
      .set('orderAsc', orderAsc.toString())
      .set('soloActivos', soloActivos);

    if (sucursalUuid) {
      params = params.set('sucursalUuid', sucursalUuid);
    }

    if (textoLibre) {
      params = params.set('textoLibre', textoLibre);
    }

    if (filtro) {
      params = params.set('filtro', filtro);
    }

    if (tipoBusqueda) {
      params = params.set('tipoBusqueda', tipoBusqueda);
    }

    return this.http.get<GetListaConductoresResponseDTO>(this.apiaryDespachadorUrl + "v1/conductores", { params })
      .pipe(map(resp => new GetListaConductoresResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaServicios(): Observable<GetListaServiciosResponseDTO> {
    return this.http.get<GetListaServiciosResponseDTO>(this.apiaryDespachadorUrl + "v2/servicios")
      .pipe(map(resp => new GetListaServiciosResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaServiciosV3(): Observable<GetListaServiciosV3ResponseDTO> {
    return this.http.get<GetListaServiciosV3ResponseDTO>(this.apiaryDespachadorUrl + "v3/servicios")
      .pipe(map(resp => new GetListaServiciosV3ResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaConductoresGestionConductores(
    uuidSucursales: string,
    kpiCode: string = '',
    mostrarSoloHH: boolean = false,
    sucDistJornadaActual: boolean = false,
    page: number,
    pageSize: number,
    orderBy: string = 'visibleId',
    orderAsc: boolean = true,
    textoLibre: string = null,
    estadoConductor: string = ''
  ): Observable<GetListaConductoresResponseDTO> {

    let params = new HttpParams()
      .set('uuidSucursales', uuidSucursales)
      .set('orderBy', orderBy)
      .set('page', page)
      .set('pageSize', pageSize)
      .set('orderAsc', orderAsc.toString())
      .set('ordenarAscendente', orderAsc.toString())
      .set('ejecutandoHorasExtra', mostrarSoloHH)
      .set('noEnSucursalPresentacion', sucDistJornadaActual);

    if (textoLibre) {
      params = params.set('textoLibre', textoLibre);
    }

    if (kpiCode) {
      params = params.set('kpiCodigo', kpiCode);
    }

    if (estadoConductor !== '' && estadoConductor !== null)
      params = params.set('filtroEstado', estadoConductor);

    return this.http.get<GetListaConductoresResponseDTO>(this.apiaryGestionConductoresUrl + "v1/conductor/listar", { params })
      .pipe(map(resp => new GetListaConductoresResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getDetalleConductor(uuid: string): Observable<GetDetalleConductorResponseDTO> {
    return this.http.get<GetDetalleConductorResponseDTO>(this.apiaryGestionConductoresUrl + `v1/conductores/${uuid}`)
      .pipe(map(resp => new GetDetalleConductorResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }


  getDetalleMovil(numeroInterno: string): Observable<GetDetalleMovilResponseDTO> {
    return this.http.get<GetDetalleMovilResponseDTO>(this.apiaryGestionBusesUrl + `v1/moviles/${numeroInterno}`)
      .pipe(map(resp => new GetDetalleMovilResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaMoviles(page: number, pageSize: number, terminalesUuids: string = ''): Observable<GetListaMovilesResponseDTO> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (terminalesUuids) {
      params = params.set('sucursalUuid', terminalesUuids);
    }
    return this.http.get<GetListaMovilesResponseDTO>(this.apiaryGestionBusesUrl + `v1/moviles`, { params })
      .pipe(map(resp => new GetListaMovilesResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaMovilesDisponibles(
    page: number = 0,
    pageSize: number = 10,
    textoLibre: string = '',
    terminalesUuids: string = '',
    orderBy: string = 'numeroInterno',
    orderAsc: boolean = true,
    estado: undefined | string = undefined,
    tipoBusqueda: string = '',
  ): Observable<GetListaMovilesResponseDTO> {
    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('orderBy', orderBy)
      .set('orderAsc', orderAsc.toString());

    if (textoLibre) {
      params = params.set('textoLibre', textoLibre);
    }

    if (terminalesUuids) {
      params = params.set('sucursalUuid', terminalesUuids);
    }

    if (estado) {
      params = params.set('filtro', estado);
    }

    if (tipoBusqueda) {
      params = params.set('tipoBusqueda', tipoBusqueda)
    }

    return this.http.get<GetListaMovilesResponseDTO>(this.apiaryDespachadorUrl + "v1/moviles", { params })
      .pipe(map(resp => new GetListaMovilesResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaViajes(page: number, pageSize: number, textoLibre: string = '', terminalesUuids: string = '', serviciosSentidos: string = ''): Observable<GetListaViajesResponseDTO> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize).set('terminalesUuids', terminalesUuids);
    if (textoLibre != '')
      params = params.set('textoLibre', textoLibre);
    if (serviciosSentidos)
      params = params.set('serviciosSentidos', serviciosSentidos);

    return this.http.get<GetListaViajesResponseDTO>(this.hostSinoptico + `v1/viajes/sinoptico`, { params })
      .pipe(map(resp => new GetListaViajesResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getDetalleViaje(uuidViaje: string): Observable<GetDetalleViajeResponseDTO> {
    return this.http.get<GetDetalleViajeResponseDTO>(this.hostSinoptico + `v1/viajes/${uuidViaje}`)
      .pipe(map(resp => new GetDetalleViajeResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getParadasViaje(uuidViaje: string): Observable<GetParadasViajeResponseDTO> {
    return this.http.get<GetParadasViajeResponseDTO>(this.apiaryDespachadorUrl + `v1/viajes/${uuidViaje}/paradas`)
      .pipe(map(resp => new GetParadasViajeResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  postFinalizarViaje(uuidViaje: string, postFinalizarViajeResquestDTO: PostFinalizarViajeResquestDTO): Observable<GeneralResponseDTO> {
    return this.http.post<GeneralResponseDTO>(this.hostSinoptico + `v1/viajes/${uuidViaje}/finalizar-viaje`, postFinalizarViajeResquestDTO)
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaJornadas(uuidSucursales: string, orderBy: string, orderAsc: boolean, page: number, pageSize: number, kpiCodigo: string,
    textoLibre: string = '', fechaDesde: string = '', fechaHasta: string = '', estado: string = ''): Observable<GetListaJorndasResponseDTO> {
    let params = new HttpParams().set('uuidSucursales', uuidSucursales).set('orderBy', orderBy);
    params = params.set('orderAsc', orderAsc).set('page', page).set('pageSize', pageSize);
    if (textoLibre != '')
      params = params.set('textoLibre', textoLibre);
    if (fechaDesde != '')
      params = params.set('fechaDesde', fechaDesde);
    if (fechaHasta != '')
      params = params.set('fechaHasta', fechaHasta);
    if (estado != '' && estado != null)
      params = params.set('filtro', estado); //filtrar por estado se ocupa campo filtro
    if (kpiCodigo != '')
      params = params.set('kpiCodigo', kpiCodigo);

    return this.http.get<GetListaJorndasResponseDTO>(this.hostSinoptico + `v1/jornadas/por-iniciar`, { params })
      .pipe(map(resp => new GetListaJorndasResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getDetalleJornada(uuid: string): Observable<GetDetalleJornadaResponseDTO> {
    return this.http.get<GetDetalleJornadaResponseDTO>(this.hostSinoptico + `v2/jornadas/${uuid}/detalle`)
      .pipe(map(resp => new GetDetalleJornadaResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putIniciarJornada(uuidJornada: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.hostSinoptico + `v1/jornadas/${uuidJornada}/iniciar`, {})
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  postCrearJornada(postCrearJornadaResquestDTO: PostCrearJornadaResquestDTO): Observable<GeneralResponseDTO> {
    return this.http.post<GeneralResponseDTO>(this.hostSinoptico + `v1/jornadas/crear`, postCrearJornadaResquestDTO)
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putCancelarJornada(uuidJornada: string, comentario: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.hostSinoptico + `v1/jornadas/${uuidJornada}/cancelar`, { comentario })
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putCambiarConductor(viajeUuid: string, conductorUuid: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryDespachadorUrl + "v1/viajes/" + viajeUuid + "/cambiar-conductor/" + conductorUuid, {})
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putCambiarBus(viajeUuid: string, busUuid: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryDespachadorUrl + "v1/viajes/" + viajeUuid + "/cambiar-movil/" + busUuid, {})
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  iniciarViaje(viajeUuid: string, combustiblePorcentaje: number): Observable<GeneralResponseDTO> {
    const body = {
      nivelCombustible: combustiblePorcentaje
    };

    return this.http.post<GeneralResponseDTO>(
      `${this.apiaryDespachadorUrl}v1/viajes/${viajeUuid}/iniciar`,
      body
    ).pipe(
      map(resp => new GeneralResponseDTO(resp)),
      catchError(error => this.handleError(error))
    );
  }

  confirmarConductorMovil(viajeUuid: string, conductorUuid: string, movilUuid: string): Observable<GeneralResponseDTO> {
    const body = {
      conductorUuid: conductorUuid,
      movilUuid: movilUuid
    };

    return this.http.post<GeneralResponseDTO>(
      `${this.apiaryDespachadorUrl}v1/viajes/${viajeUuid}/confirmar-conductor-movil`,
      body
    ).pipe(
      map(resp => new GeneralResponseDTO(resp)),
      catchError(error => this.handleError(error))
    );
  }

  putActualizarHoraJornada(uuidJornada: string, putActualizarHoraJornadaResquestDTO: PutActualizarHoraJornadaResquestDTO): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.hostSinoptico + `v1/jornadas/${uuidJornada}/cambiar-hora`, putActualizarHoraJornadaResquestDTO)
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putActualizarSucursalJornada(uuidJornada: string, uuidSucursal: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.hostSinoptico + `v1/jornadas/${uuidJornada}/cambiar-sucursal`, { uuidSucursal: uuidSucursal })
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  /* WS ya no se utiliza ya que quedo obsoleto por ajustes backend en apiary donde se dejo un solo WS global para todos los kpi
  getKPISgestionJornada(terminalesUuids: string):  Observable<GetKPISgestionJornadaResponseDTO> {
    let params = new HttpParams().set('terminalesUuids', terminalesUuids);
    return this.http.get<GetKPISgestionJornadaResponseDTO>(this.apiaryGestionJornadaUrl + `v1/gestion-jornada/kpis`, {params})
      .pipe(map(resp => new GetKPISgestionJornadaResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }*/

  getKPISporSeccion(terminalesUuids: string, codigoSeccion: string, fechaDesde: string = '', fechaHasta: string = ''): Observable<GetKPISgestionJornadaResponseDTO> {
    let params = new HttpParams().set('terminalesUuids', terminalesUuids);
    if (fechaDesde != '')
      params = params.set('fechaDesde', fechaDesde);
    if (fechaHasta != '')
      params = params.set('fechaHasta', fechaHasta);

    return this.http.get<GetKPISgestionJornadaResponseDTO>(this.hostDespachador + `v1/kpis/seccion/${codigoSeccion}`, { params })
      .pipe(map(resp => new GetKPISgestionJornadaResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getKPISDespachador(): Observable<GetKPISgestionJornadaResponseDTO> {
    return this.http.get<GetKPISgestionJornadaResponseDTO>(this.apiaryDespachadorUrl + `/v1/kpis/seccion/codigoSeccion?terminalesUuids=123e4567-e89b-12d3-a456-426614174000%2C123e4567-e89b-12d3-a456-426614174001`)
      .pipe(map(resp => new GetKPISgestionJornadaResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getKPISGestionConductores(): Observable<GetKPISGestionConductoresResponseDTO> {
    return this.http.get<GetKPISGestionConductoresResponseDTO>(`https://private-83ff1d-condespachadorviajes.apiary-mock.com/api/v1/kpis/seccion/codigoSeccion`)
      .pipe(map(resp => new GetKPISGestionConductoresResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getViajesDespachador(
    page: number = 0,
    pageSize: number = 10,
    textoLibre: string = '',
    kpiCodigo: string = '',
    terminalesUuids: string = '',
    orderBy: string = 'fechahoraInicio',
    orderAsc: boolean = true,
    serviciosSentidos: string = ''
  ): Observable<GetListaViajesResponseDTO> {
    console.log('Requesting page:', page, 'textoLibre:', textoLibre, 'kpiCodigo:', kpiCodigo, 'terminalesUuids:', terminalesUuids, 'orderBy:', orderBy, 'orderAsc:', orderAsc, 'serviciosSentidos:', serviciosSentidos); // Log the parameters for debugging

    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('orderBy', orderBy)
      .set('orderAsc', orderAsc.toString());

    if (textoLibre) {
      params = params.set('textoLibre', textoLibre);
    }

    if (kpiCodigo) {
      params = params.set('kpiCodigo', kpiCodigo);
    }

    if (terminalesUuids) {
      params = params.set('terminalesUuids', terminalesUuids);
    }

    if (serviciosSentidos) {
      params = params.set('serviciosSentidos', serviciosSentidos);
    }

    return this.http.get<GetListaViajesResponseDTO>(this.apiaryDespachadorUrl + 'v1/viajes/despachador', { params })
      .pipe(
        map(resp => new GetListaViajesResponseDTO(resp)),
        catchError((error: any) => this.handleError(error))
      );
  }

  getListaSucursales(): Observable<GetListaSucursalesResponseDTO> {
    return this.http.get<GetListaSucursalesResponseDTO>(this.hostSinoptico + `v1/sucursales`)
      .pipe(map(resp => new GetListaSucursalesResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getServiciosSentidos(): Observable<any> {
    return this.http.get<any>(this.apiaryDespachadorUrl + `v1/servicios-sentidos`)
      .pipe(catchError((error: any) => this.handleError(error)));
  }

  postCambiarEstadoGestionBuses(estado: string, minutos: string, numeroInterno: string): Observable<GeneralResponseDTO> {
    console.log(`Cambiando el estado del movil ${numeroInterno} a ${estado} durante ${minutos} minutos`);
    const body = {
      estado: estado,
      minutos: minutos
    };
    return this.http.post<GeneralResponseDTO>(`${this.apiaryGestionBusesUrl}v1/moviles/${numeroInterno}/cambiar-estado`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  postExtenderTiempoGetionBuses(minutos: string, numeroInterno: string): Observable<GeneralResponseDTO> {
    console.log(`Extendiendo el tiempo del movil ${numeroInterno} durante ${minutos} minutos`);
    const body = {
      minutos: minutos
    };
    return this.http.post<GeneralResponseDTO>(`${this.apiaryGestionBusesUrl}v1/moviles/${numeroInterno}/extender-tiempo`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  //El siguiente método es temporal, ya que el original estaba siendo modificado y podría afectar la demo al cliente
  getListaConductoresSoloParaPresentacion(): Observable<GetListaConductoresResponseDTO> {
    return this.http.get<GetListaConductoresResponseDTO>(this.apiaryDespachadorUrl + "v1/conductores")
      .pipe(map(resp => new GetListaConductoresResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  private handleError(error: any) {
    /*if( error.status === 401 ){
      console.log('error 401 handle error api', error);
      this.userService.cleanSesion();
      this.router.navigate(['/login']);
      return throwError(error);
    }
    console.log('api handle error');*/
    return throwError(error);
  }

  putCambiarEstadoGestionConductores(idConductor: string, nuevoEstado: string, minutos: number = null): Observable<GeneralResponseDTO> {
    console.log(`Cambiando el estado del conductor ${idConductor} a ${nuevoEstado}`);
    //CON-1056: minutos es opcional; si no va, el back aplica el tiempo sugerido del estado
    const body = {
      codigoEstado: nuevoEstado,
      ...(minutos != null && { minutos: minutos }),
    };
    return this.http.put<GeneralResponseDTO>(`${this.apiaryGestionConductoresUrl}v1/conductor/${idConductor}/estado`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  /** CON-1056: reglas de duracion de los estados con vale, para pintar la celda de tiempo. */
  getConfiguracionEstadosConductor(): Observable<GetConfiguracionEstadosConductorResponseDTO> {
    return this.http.get<GetConfiguracionEstadosConductorResponseDTO>(`${this.apiaryGestionConductoresUrl}v1/conductor/estados/configuracion`)
      .pipe(map(resp => new GetConfiguracionEstadosConductorResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putFinalizarJornadaGestionConductores(
    idConductor: string,
    codigoEstado: string,
    uuidJornada: string,
    codigoEstadoJornada: string,
    fechaTermino: string,
    motivoCierre: string = 'desconocido',
    detalleCierre: string = ''): Observable<GeneralResponseDTO> {
    //console.log(`Cambiando el estado del conductor ${} a ${}`);
    const body = {
      codigoEstado: codigoEstado,
      jornada: [{
        uuid: uuidJornada,
        codigoEstado: codigoEstadoJornada,
        fechaTermino: fechaTermino,
      }],
      motivoCierre: motivoCierre,
      detalleCierre: detalleCierre,
    };
    return this.http.put<GeneralResponseDTO>(`${this.apiaryGestionConductoresUrl}v1/conductor/${idConductor}/finalizar`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  putActualizarSucursalConductor(uuidConductor: string, uuidSucursal: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryGestionConductoresUrl + `v1/conductor/${uuidConductor}/cambiar-sucursal`, { uuidSucursal: uuidSucursal })
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putEditarInicioViaje(viajeUuid: string, nuevaHoraInicio: string): Observable<GeneralResponseDTO> {
    const body = {
      nuevaHoraInicio: nuevaHoraInicio
    };
    return this.http.put<GeneralResponseDTO>(`${this.apiaryDespachadorUrl}v1/viajes/${viajeUuid}/editar-inicio`, body)
      .pipe(
        map(resp => new GeneralResponseDTO(resp)),
        catchError(error => this.handleError(error))
      );
  }

  getListaParaderos(
    page: number = 0,
    pageSize: number = 10,
    textoLibre: string = '',
    orderBy: string = 'nombre',
    orderAsc: boolean = true
  ): Observable<GetListaParaderosResponseDTO> {
    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('orderBy', orderBy)
      .set('orderAsc', orderAsc.toString());

    if (textoLibre) {
      params = params.set('textoLibre', textoLibre);
    }

    return this.http.get<GetListaParaderosResponseDTO>(this.apiaryDespachadorUrl + 'v1/paraderos', { params })
      .pipe(
        map(resp => new GetListaParaderosResponseDTO(resp)),
        catchError((error: any) => this.handleError(error))
      );
  }

  postCrearViajeNoComercialDespachador(
    descripcion,
    textoParaderoOrigen,
    sucursalOrigenUuid,
    fechaHoraInicio,
    textoParaderoDestino,
    sucursalDestinoUuid,
    fechaHoraTermino
  ): Observable<GeneralResponseDTO> {
    const body = {
      descripcion: descripcion,
      textoLibreOrigen: textoParaderoOrigen,
      sucursalOrigenUuid: sucursalOrigenUuid,
      fechaHoraInicio: fechaHoraInicio,
      textoLibreDestino: textoParaderoDestino,
      sucursalDestinoUuid: sucursalDestinoUuid,
      fechaHoraTermino: fechaHoraTermino,
    };

    return this.http.put<GeneralResponseDTO>(`${this.apiaryDespachadorUrl}v2/viajes/crear-no-comercial`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  putCrearViajeComercialV3Despachador(
    fechaHoraSalidaTerminalV3,
    fechaHoraInicioViajeV3,
    fechaHoraTerminoViajeV3,
    fechaHoraLlegadaTerminalV3,
    sucursalOrigenUuid,
    sucursalDestinoUuid,
    servicioV3Uuid
  ): Observable<GeneralResponseDTO> {
    const body = {
      fechaHoraSalidaTerminal: fechaHoraSalidaTerminalV3,
      fechaHoraInicioViaje: fechaHoraInicioViajeV3,
      fechaHoraTerminoViaje: fechaHoraTerminoViajeV3,
      fechaHoraLlegadaTerminal: fechaHoraLlegadaTerminalV3,
      sucursalOrigenUuid,
      sucursalDestinoUuid,
      servicioV3Uuid
    };

    return this.http.put<GeneralResponseDTO>(`${this.apiaryDespachadorUrl}v3/viajes/crear-comercial`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  putCancelarViajeDespachador(viajeUuid: string, motivo: string, comentario: string) {
    const body = {
      motivo: motivo,
      comentario: comentario
    };
    return this.http.put<GeneralResponseDTO>(`${this.apiaryDespachadorUrl}v1/viajes/${viajeUuid}/cancelar`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  postCrearViajeEspecialDespachador(
    nombre,
    descripcion,
    textoParaderoOrigen,
    sucursalOrigenUuid,
    fechaHoraInicio,
    textoParaderoDestino,
    sucursalDestinoUuid,
    fechaHoraTermino
  ): Observable<GeneralResponseDTO> {
    const body = {
      nombre: nombre,
      descripcion: descripcion,
      textoLibreOrigen: textoParaderoOrigen,
      sucursalOrigenUuid: sucursalOrigenUuid,
      fechaHoraInicio: fechaHoraInicio,
      textoLibreDestino: textoParaderoDestino,
      sucursalDestinoUuid: sucursalDestinoUuid,
      fechaHoraTermino: fechaHoraTermino,
    };
    return this.http.put<GeneralResponseDTO>(`${this.apiaryDespachadorUrl}v2/viajes/crear-especial`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  postCrearViajeDespachador(codigoServicio: string,
    fechaHoraSalidaTerminal: string,
    fechaHoraInicio: string,
    fechaHoraTermino: string,
    fechaHoraLlegadaTerminal: string): Observable<GeneralResponseDTO> {
    const body = {
      codigoServicio: codigoServicio,
      fechaHoraSalidaTerminal: fechaHoraSalidaTerminal,
      fechaHoraInicio: fechaHoraInicio,
      fechaHoraTermino: fechaHoraTermino,
      fechaHoraLlegadaTerminal: fechaHoraLlegadaTerminal,
    };
    return this.http.put<GeneralResponseDTO>(`${this.apiaryDespachadorUrl}v2/viajes/crear-comercial`, body)
      .pipe(catchError((error: GeneralResponseDTO) => this.handleError(error)));
  }

  crearViaje(viajeData: any): Observable<GeneralResponseDTO> {
    return this.http.post<GeneralResponseDTO>(this.apiaryDespachadorUrl + 'v1/viajes', viajeData)
      .pipe(
        map(resp => new GeneralResponseDTO(resp)),
        catchError((error: any) => this.handleError(error))
      );
  }

  putQuitarConductor(viajeUuid: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryDespachadorUrl + `v1/viajes/${viajeUuid}/quitar-conductor`, {})
      .pipe(
        map(resp => new GeneralResponseDTO(resp)),
        catchError((error: any) => this.handleError(error))
      );
  }

  putQuitarBus(viajeUuid: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryDespachadorUrl + `v1/viajes/${viajeUuid}/quitar-movil`, {})
      .pipe(
        map(resp => new GeneralResponseDTO(resp)),
        catchError((error: any) => this.handleError(error))
      );
  }

  getPDF(): Observable<PdfDTO> {
    return this.http.get<PdfDTO>(this.hostSinoptico + `v1/pdf/base64`)
      .pipe(map(resp => new PdfDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getRutaViajePDF(uuidViaje: string): Observable<PdfDTO> {
    return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/ruta-viaje/${uuidViaje}`)
      .pipe(map(resp => new PdfDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getInicioJornadaPDF(uuidJornada: string): Observable<PdfDTO> {
    // return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/inicio-jornada/${uuidJornada}`)
    return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/jornada/${uuidJornada}`)
      .pipe(map(resp => new PdfDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getFinJornadaPDF(uuidJornada: string): Observable<PdfDTO> {
    // return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/fin-jornada/${uuidJornada}`)
    return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/jornada/${uuidJornada}`)
      .pipe(map(resp => new PdfDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getColacionPDF(uuidConductor: string): Observable<PdfDTO> {
    return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/colacion/${uuidConductor}`)
      .pipe(map(resp => new PdfDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  /**
   * CON-1056: vale termico del estado en que esta el conductor ahora. Un solo endpoint para los
   * cinco estados, sirve tanto para imprimir al entrar al estado como para reimprimir.
   */
  getEstadoConductorPDF(uuidConductor: string): Observable<PdfDTO> {
    return this.http.get<PdfDTO>(this.hostSinoptico + `v1/voucher/estado-conductor/${uuidConductor}`)
      .pipe(map(resp => new PdfDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  getListaViajesEspecialesDespachador(): Observable<GetListaViajesEspecialesResponseDTO> {
    return this.http.get<GetListaViajesEspecialesResponseDTO>(this.apiaryDespachadorUrl + "v2/viajes/especiales/listado")
      .pipe(map(resp => new GetListaViajesEspecialesResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putDeshacerFinJornada(uuidConductor: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryGestionConductoresUrl + `v1/conductor/${uuidConductor}/deshacer-fin-jornada`, {})
      .pipe(
        map(resp => new GeneralResponseDTO(resp)),
        catchError((error: any) => this.handleError(error))
      );
  }

  getListaMotivosCierreJornadaGestionDeConductores(): Observable<GetListaMotivosCierreJornadaResponseDTO> {
    return this.http.get<GetListaMotivosCierreJornadaResponseDTO>(this.apiaryGestionConductoresUrl + "v1/motivo-cierre-jornada")
      .pipe(map(resp => new GetListaMotivosCierreJornadaResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

  putActualizarSucursalMovil(numeroInterno: string, uuidSucursal: string): Observable<GeneralResponseDTO> {
    return this.http.put<GeneralResponseDTO>(this.apiaryGestionConductoresUrl + `v1/moviles/${numeroInterno}/${uuidSucursal}/cambiar-terminal`, {})
      .pipe(map(resp => new GeneralResponseDTO(resp)), catchError((error: any) => this.handleError(error)));
  }

}
